const UserProfileInitialState = {
  profile_image:'',
}

export default UserProfileInitialState;
